import * as React from 'react';

/** Independent instances fence independent loaders. Changing scope invalidates pending results. */
export function useLatestRequest(scope?: unknown) {
  const generation = React.useRef(0);
  const invalidateRequests = React.useCallback(() => { generation.current += 1; }, []);
  const startRequest = React.useCallback(() => {
    const request = ++generation.current;
    return () => request === generation.current;
  }, []);

  React.useLayoutEffect(() => {
    invalidateRequests();
    return invalidateRequests;
  }, [scope, invalidateRequests]);

  return { startRequest, invalidateRequests };
}
